/** Modulo Classificacao / categoria_prato (150) — codigos em contracts/enums.yaml */
export const CLASSIFICACAO_ACAO = {
  CRIAR: 1501,
  ATUALIZAR: 1502,
  REMOVER: 1503,
} as const;

export const CLASSIFICACAO_ACOES_MODULO = [
  CLASSIFICACAO_ACAO.CRIAR,
  CLASSIFICACAO_ACAO.ATUALIZAR,
  CLASSIFICACAO_ACAO.REMOVER,
] as const;
